import {
  allMetrics as metrics,
  metricToDisplayNameMap,
  defaultGridColumns,
  AccountsMode,
} from '@bingads-webui-campaign/overview-cards-common';

const ComparisonValues = {
  PerformanceMetrics: 'PerformanceMetrics',
  PerformanceMetricsChange: 'PerformanceMetricsChange',
  PerformanceMetricsChangePercentage: 'PerformanceMetricsChangePercentage',
};

export const getHeaderPropsFromPreferenceForPerformanceTable = ({
  cardPreference,
  patchPreference,
  i18n,
  dateRange,
}) => {
  const initialSelectedValue = (cardPreference && cardPreference.selectedComparisonValue) || ComparisonValues.PerformanceMetrics;
  if (!dateRange.compared) {
    return { options: [], initialSelectedValue };
  }
  return ({
    options: [
      {
        value: ComparisonValues.PerformanceMetrics,
        displayName: i18n.getString(_TL_('Value')),
      },
      {
        value: ComparisonValues.PerformanceMetricsChange,
        displayName: i18n.getString(_TL_('Change')),
      },
      {
        value: ComparisonValues.PerformanceMetricsChangePercentage,
        displayName: i18n.getString(_TL_('Change %')),
      },
    ],
    initialSelectedValue,
    onOptionSelected: (value) => {
      patchPreference({
        selectedComparisonValue: value,
      });
    },
  });
};

export const getTablePropsFromPreferenceForPerformanceTable = ({
  cardPreference,
  patchPreference,
  permissions,
  navigationLevel,
  i18n,
  campaignType,
}) => {
  const selectedColumns = (cardPreference && cardPreference.selectedColumns) || defaultGridColumns;
  const allMetrics = metrics(permissions, AccountsMode.Expert, campaignType).map(metric => ({
    key: metric,
    displayName: i18n.getString(metricToDisplayNameMap[metric]),
  }));
  const initialSelectedMetrics = selectedColumns.map(column => allMetrics.find(metric => metric.key === column));
  return {
    initialSelectedMetrics,
    allMetrics,
    initialSortColumn: (cardPreference && cardPreference.sortColumn) || selectedColumns[0],
    initialSortDirection: (cardPreference && cardPreference.sortDirection) || 'descending',
    patchPreference,
    navigationLevel,
    campaignType,
  };
};

function isNullOrUndefined(value) {
  return value == null; // This covers both null and undefined
}

export const isTablePreferenceValid = ({
  cardPreference,
  permissions,
  campaignType,
}) => {
  const metricsKeys = metrics(permissions, AccountsMode.Expert, campaignType);
  if (!cardPreference
    || (!isNullOrUndefined(cardPreference.selectedColumns) && cardPreference.selectedColumns.length !== 3)
    || (!isNullOrUndefined(cardPreference.selectedColumns) && cardPreference.selectedColumns.some(column => !metricsKeys.includes(column)))
    || (!isNullOrUndefined(cardPreference.selectedComparisonValue) && !Object.values(ComparisonValues).includes(cardPreference.selectedComparisonValue))
    || (!isNullOrUndefined(cardPreference.sortColumn) && !metricsKeys.includes(cardPreference.sortColumn))
    || (!isNullOrUndefined(cardPreference.sortDirection) && (cardPreference.sortDirection !== 'descending' && cardPreference.sortDirection !== 'ascending'))
  ) {
    return false;
  }

  return true;
};

export const getDefaultPerformanceTablePreference = () => ({
  selectedColumns: defaultGridColumns,
  sortColumn: defaultGridColumns[0],
  sortDirection: 'descending',
  selectedComparisonValue: ComparisonValues.PerformanceMetrics,
});

export const getDfmPreferenceObjectForPerformanceTable = cardPreference => ({
  columns: cardPreference.selectedColumns,
  orderby: cardPreference.sortColumn,
  direction: cardPreference.sortDirection === 'descending' ? -1 : 1,
  selectedMenuItem: cardPreference.selectedComparisonValue,
});

